/* eslint react/no-danger: 0 */

import PropTypes from 'prop-types';
import React from 'react';
import { sanitizeContent } from '../utils/helper';

import '../global-sass/main.scss';

const renderSpecDescription = (prefs, specIds, specObj) =>
	specIds.map(id => {
		const specDescription = (specObj[id] && specObj[id].description) || '';
		const specDetail = (specObj[id] && specObj[id].detail) || '';
		const specItemClasses = ['spec-item'];
		const specItemDescriptionClasses = ['spec-item-description'];

		const { isSpecDescriptionMuted = 'true' } = prefs;

		let sanitizedSpecDetail;
		let sanitizedSpecDescription = sanitizeContent(specDescription);

		if (specDetail) {
			sanitizedSpecDescription = sanitizedSpecDescription.concat(': ');
			sanitizedSpecDetail = sanitizeContent(specDetail);

			// checking against 'false' in case pref doesn't exist and is not false
			// because 'true' is the default state
			if (isSpecDescriptionMuted !== 'false') {
				specItemDescriptionClasses.push('text-muted');
			}
		}

		return (
			<li key={id} className={specItemClasses.join(' ')}>
				<span
					className={specItemDescriptionClasses.join(' ')}
					dangerouslySetInnerHTML={{
						__html: sanitizedSpecDescription
					}}
				/>
				{!!specDetail && (
					<span
						className="spec-item-detail"
						dangerouslySetInnerHTML={{
							__html: sanitizedSpecDetail
						}}
					/>
				)}
			</li>
		);
	});

const renderSpecDisclaimers = (prefs, specDisclaimers) => {
	const { disclaimerFontSize = 'xxsmall' } = prefs;

	return (
		<ul
			className={`spec-disclaimers list-unstyled text-muted ddc-font-size-${disclaimerFontSize} pl-5 ml-2`}
		>
			{specDisclaimers.map(id => {
				const sanitizedSpecDisclaimers = sanitizeContent(id);

				return (
					<li
						key={id}
						dangerouslySetInnerHTML={{
							__html: sanitizedSpecDisclaimers
						}}
					/>
				);
			})}
		</ul>
	);
};

export default class SpecDescription extends React.Component {
	render() {
		const { prefs, specIds, specification } = this.props;

		const specObj = specification.reduce(
			(obj, itm) => ({
				...obj,
				[itm.id]: itm.spec
			}),
			{}
		);

		// filter is returning an arrays of spec ids for each category
		// map is then returning values of disclaimers for those ids
		// Set then returns an array of unique disclaimer values
		const specDisclaimers = [
			...new Set(
				specIds
					.filter(id => specObj[id].disclaimers)
					.map(id => specObj[id].disclaimers[0])
			)
		];
		const hasSpecDisclaimers = !!specDisclaimers.length;

		return (
			<React.Fragment>
				<ul className="spec-list list-unstyled list-spaced line-height-condensed mt-4 ml-2 pl-5">
					{renderSpecDescription(prefs, specIds, specObj)}
				</ul>
				{hasSpecDisclaimers &&
					renderSpecDisclaimers(prefs, specDisclaimers)}
			</React.Fragment>
		);
	}
}

SpecDescription.propTypes = {
	prefs: PropTypes.shape({
		disclaimerFontSize: PropTypes.string,
		isSpecDescriptionMuted: PropTypes.string
	}),
	specIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	specification: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			spec: PropTypes.object.isRequired
		})
	).isRequired
};

SpecDescription.defaultProps = {
	prefs: {
		disclaimerFontSize: 'xxsmall',
		isSpecDescriptionMuted: 'true'
	}
};



// WEBPACK FOOTER //
// ./src/components/SpecDescription.jsx